
import {define} from "observable:runtime";
import asset1 from "./style.css?url";
import asset2 from "./favicon.svg?url";

const assets = new Map([
  ["./style.css", asset1],
  ["./favicon.svg", asset2]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const {createUI, installHashImportBanner, installThemeToggle, runWithTimeout} = await import("./lib/helpers.js").then((module) => {
  if (!("createUI" in module)) throw new SyntaxError(`export 'createUI' not found`);
  if (!("installHashImportBanner" in module)) throw new SyntaxError(`export 'installHashImportBanner' not found`);
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  if (!("runWithTimeout" in module)) throw new SyntaxError(`export 'runWithTimeout' not found`);
  return module;
});
installThemeToggle({ html, display });
installHashImportBanner({ html, display });
const { codeEditor, ok, err, hint, consoleOutput } = createUI({ html });
return {createUI,installHashImportBanner,installThemeToggle,runWithTimeout,codeEditor,ok,err,hint,consoleOutput};
},
    inputs: ["html","display"],
    outputs: ["createUI","installHashImportBanner","installThemeToggle","runWithTimeout","codeEditor","ok","err","hint","consoleOutput"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-5`),
    expanded: [],
    variables: []
  },
  {
    id: 5,
    body: (view,codeEditor) => {
const demo_while = view(codeEditor("loops:while", {
  value: 'let i = 1\n\nwhile (i <= 10) {\n  console.log(i)\n  i = i + 1\n}\n\nconsole.log("Fertig!")'
}));
return {demo_while};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_while"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-6`),
    expanded: [],
    variables: []
  },
  {
    id: 6,
    body: async (display,consoleOutput,runWithTimeout,demo_while) => {
display(consoleOutput(await runWithTimeout(demo_while)));
},
    inputs: ["display","consoleOutput","runWithTimeout","demo_while"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-9`),
    expanded: [],
    variables: []
  },
  {
    id: 9,
    body: (view,codeEditor) => {
const demo_for = view(codeEditor("loops:for", {
  value: 'for (let i = 1; i <= 10; i++) {\n  console.log(i)\n}\n\nconsole.log("Fertig!")'
}));
return {demo_for};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_for"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-10`),
    expanded: [],
    variables: []
  },
  {
    id: 10,
    body: async (display,consoleOutput,runWithTimeout,demo_for) => {
display(consoleOutput(await runWithTimeout(demo_for)));
},
    inputs: ["display","consoleOutput","runWithTimeout","demo_for"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-13`),
    expanded: [],
    variables: []
  },
  {
    id: 13,
    body: (view,codeEditor) => {
const demo_break = view(codeEditor("loops:break", {
  value: 'let i = 1\n\nwhile (i <= 100) {\n  if (i > 3) {\n    break\n  }\n  console.log(i)\n  i = i + 1\n}\n\nconsole.log("Fertig!")'
}));
return {demo_break};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_break"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-14`),
    expanded: [],
    variables: []
  },
  {
    id: 14,
    body: async (display,consoleOutput,runWithTimeout,demo_break) => {
display(consoleOutput(await runWithTimeout(demo_break)));
},
    inputs: ["display","consoleOutput","runWithTimeout","demo_break"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-16`),
    expanded: [],
    variables: []
  },
  {
    id: 16,
    body: (view,codeEditor) => {
const demo_continue = view(codeEditor("loops:continue", {
  value: 'let i = 0\n\nwhile (i < 10) {\n  i = i + 1\n  if (i % 2 == 0) {\n    continue // gerade Zahlen überspringen\n  }\n  console.log(i)\n}'
}));
return {demo_continue};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_continue"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-17`),
    expanded: [],
    variables: []
  },
  {
    id: 17,
    body: async (display,consoleOutput,runWithTimeout,demo_continue) => {
display(consoleOutput(await runWithTimeout(demo_continue)));
},
    inputs: ["display","consoleOutput","runWithTimeout","demo_continue"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-19`),
    expanded: [],
    variables: []
  },
  {
    id: 19,
    body: (view,codeEditor) => {
const uebung_code = view(codeEditor("loops:final", {
  value: ""
}));
return {uebung_code};
},
    inputs: ["view","codeEditor"],
    outputs: ["uebung_code"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-20`),
    expanded: [],
    variables: []
  },
  {
    id: 20,
    body: async (runWithTimeout,uebung_code) => {
const uebungRun = await runWithTimeout(uebung_code);
return {uebungRun};
},
    inputs: ["runWithTimeout","uebung_code"],
    outputs: ["uebungRun"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-21`),
    expanded: [],
    variables: []
  },
  {
    id: 21,
    body: (display,consoleOutput,uebungRun) => {
display(consoleOutput(uebungRun));
},
    inputs: ["display","consoleOutput","uebungRun"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-22`),
    expanded: [],
    variables: []
  },
  {
    id: 22,
    body: (uebung_code,uebungRun,display,hint,html,err,ok) => {
{
  const src = uebung_code;
  const usesWhile = /\bwhile\s*\(/.test(src);
  const usesMod = /%/.test(src);
  const has123 = /\b123\b/.test(src);
  const numbers = uebungRun.logs.map(l => Number(l.trim())).filter(n => Number.isFinite(n));
  const startsAt123 = numbers[0] === 123;
  const reachesOne = numbers.includes(1);
  const max = Math.max(...numbers, 0);

  if (!src.trim())
    display(hint(html`Fang an mit <code>let n = 123</code> und einer <code>while</code>-Schleife.`));
  else if (uebungRun.timedOut)
    display(err(html`Endlosschleife erkannt — vermutlich vergisst du, <code>n</code> zu verändern, oder die Bedingung wird nie <code>false</code>.`));
  else if (uebungRun.error)
    display(err(html`Fehler: ${uebungRun.error}`));
  else if (!has123)
    display(err(html`Du sollst mit der Zahl <code>123</code> starten.`));
  else if (!usesWhile)
    display(err(html`Du brauchst eine <code>while</code>-Schleife.`));
  else if (!usesMod)
    display(err(html`Du brauchst <code>%</code>, um zu prüfen, ob eine Zahl gerade oder ungerade ist.`));
  else if (numbers.length < 5)
    display(err(html`Du loggst zu wenige Zahlen — die Folge ist deutlich länger.`));
  else if (!startsAt123)
    display(err(html`Die erste geloggte Zahl sollte <code>123</code> sein, war aber <code>${numbers[0]}</code>.`));
  else if (!reachesOne)
    display(err(html`Deine Folge erreicht nie <code>1</code> — vielleicht stoppst du zu früh?`));
  else if (max !== 628)
    display(err(html`Die größte Zahl in deiner Folge sollte <code>628</code> sein, ist aber <code>${max}</code>. Vielleicht stimmt die Berechnung nicht ganz?`));
  else
    display(ok(html`🎉 Collatz für 123 läuft korrekt durch! ${numbers.length} Zahlen, Maximum <code>628</code>.`));
}
},
    inputs: ["uebung_code","uebungRun","display","hint","html","err","ok"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
